import { render } from "./WebInfo.vue?vue&type=template&id=65f59817&scoped=true"
import script from "./WebInfo.vue?vue&type=script&lang=js"
export * from "./WebInfo.vue?vue&type=script&lang=js"

import "./WebInfo.vue?vue&type=style&index=0&id=65f59817&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65f59817"

export default script